export const product_images = {

    izaje: [
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/1_Herramienta_de_izaje_tipo_C para_polea_de_faja_transportadora/1E_800h.jpg"),
            name: 'Herramienta de izaje tipo C para polea de faja transportadora',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/1_Herramienta_de_izaje_tipo_C para_polea_de_faja_transportadora/2E.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/1_Herramienta_de_izaje_tipo_C para_polea_de_faja_transportadora/1E.jpg") }
            ]
        },
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/2_Herramienta_de_izaje_para_retiro_de_placas_para_filtros_LAROX/1C_800h.jpg"),
            name: 'Herramienta de izaje para retiro de placas para filtros LAROX',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/2_Herramienta_de_izaje_para_retiro_de_placas_para_filtros_LAROX/2C.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/2_Herramienta_de_izaje_para_retiro_de_placas_para_filtros_LAROX/1C.jpg") }
            ]
        },
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/3_Herramienta_de_izaje_para_retiro_de_chute_spoon/1A_800h.jpg"),
            name: 'Herramienta de izaje para retiro de chute spoon',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/3_Herramienta_de_izaje_para_retiro_de_chute_spoon/2A.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/3_Herramienta_de_izaje_para_retiro_de_chute_spoon/1A.jpg") }
            ]
        },
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/4_Herramienta_de_izaje_para_HEAD_de_chancadora_secundaria/2_800h.jpg"),
            name: 'Herramienta de izaje para HEAD de chancadora secundaria',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/4_Herramienta_de_izaje_para_HEAD_de_chancadora_secundaria/1.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/4_Herramienta_de_izaje_para_HEAD_de_chancadora_secundaria/2.jpg") }
            ]
        },
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/4_Herramienta_de_izaje_para_HEAD_de_chancadora_secundaria_v2/1D_800h.jpg"),
            name: 'Herramienta de izaje para HEAD de chancadora secundaria V2',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/4_Herramienta_de_izaje_para_HEAD_de_chancadora_secundaria_v2/1D.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/4_Herramienta_de_izaje_para_HEAD_de_chancadora_secundaria_v2/2D.jpg") }
            ]
        },
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/6_Herramienta_de_izaje_para_segmento_de_molino_de_bolas/1B_800h.jpg"),
            name: 'Herramienta de izaje para segmento de molino de bolas',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/6_Herramienta_de_izaje_para_segmento_de_molino_de_bolas/1B.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/6_Herramienta_de_izaje_para_segmento_de_molino_de_bolas/2B.jpg") }
            ]
        },
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/7_Herramienta_de_izaje_para_spider_bushing_de_chancadora_primaria/1F_800h.jpg"),
            name: 'Herramienta de izaje para spider bushing de chancadora primaria',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/7_Herramienta_de_izaje_para_spider_bushing_de_chancadora_primaria/1F.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/7_Herramienta_de_izaje_para_spider_bushing_de_chancadora_primaria/2F.jpg") }
            ]
        },
        {
            path: require("../images/productos/1_Debajo_del_gancho_BTH/8_Herramienta_de_izaje_tipo_C_ajustable_para_poleas_de_fajas_transportadoras/Yugo_Presentacion/PRE06_800h.jpg"),
            name: 'Herramienta de izaje tipo C ajustable para poleas de fajas transportadoras',
            variants: [
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/8_Herramienta_de_izaje_tipo_C_ajustable_para_poleas_de_fajas_transportadoras/Yugo_Presentacion/PRE01.jpg") },
                { path: require("../images/productos/1_Debajo_del_gancho_BTH/8_Herramienta_de_izaje_tipo_C_ajustable_para_poleas_de_fajas_transportadoras/Yugo_Presentacion/PRE06.jpg") }
            ]
        }

    ],
    concavos: [
        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/02_Soporte de mainshaft/SOPORTE MAINSHAFT_04_800h.jpg"),
            name: 'Soporte de mainshaft',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/02_Soporte de mainshaft/SOPORTE MAINSHAFT_02_800h.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/02_Soporte de mainshaft/SOPORTE MAINSHAFT_03_800h.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/02_Soporte de mainshaft/SOPORTE MAINSHAFT_05_800h.jpg") }
            ]
        },
        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 01_800h.jpg"),
            name: 'Plataforma de acceso a mainshaft',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 01_800h.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 03_800h.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 05_800h.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 07_800h.jpg") }
            ]
        },

        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/03_Escalera_de_acceso_a_Dump_Pocket/a_800h.jpg"),
            name: 'Escalera de acceso a Dump Pocket',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/03_Escalera_de_acceso_a_Dump_Pocket/a.png") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/03_Escalera_de_acceso_a_Dump_Pocket/b.png") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/03_Escalera_de_acceso_a_Dump_Pocket/c.png") }
            ]
        },

        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/04_Plataforma de instalación a grillete de mainshaft/Estrobado 04_800h.jpg"),
            name: 'Plataforma de instalación a grillete de mainshaft',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/04_Plataforma de instalación a grillete de mainshaft/Estrobado 04.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/04_Plataforma de instalación a grillete de mainshaft/Estrobado 06.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/04_Plataforma de instalación a grillete de mainshaft/Estrobado 02.jpg") }
            ]
        },

        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/05_Calentador de Backing/Calentador - 06_800h.jpg"),
            name: 'Calentador de Backing',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/05_Calentador de Backing/Calentador - 01.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/05_Calentador de Backing/Calentador - 04.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/05_Calentador de Backing/Calentador - 06.jpg") }
            ]
        },
        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/06_Bandejas para retiro de cóncavos/Bandejas _ 01_800h.jpg"),
            name: 'Bandejas para retiro de cóncavos',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/06_Bandejas para retiro de cóncavos/Bandejas _ 01.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/06_Bandejas para retiro de cóncavos/Bandejas _ 02.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/06_Bandejas para retiro de cóncavos/Bandejas _ 03.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/06_Bandejas para retiro de cóncavos/Bandejas _ 05.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/06_Bandejas para retiro de cóncavos/Bandejas _ 06.jpg") }
            ]
        },
        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/07_Barrera alrededor de cóncavos/Corralito_03_800h.jpg"),
            name: 'Barrera alrededor de cóncavos',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/07_Barrera alrededor de cóncavos/Corralito_01.1.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/07_Barrera alrededor de cóncavos/Corralito_01.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/07_Barrera alrededor de cóncavos/Corralito_02.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/07_Barrera alrededor de cóncavos/Corralito_03.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/07_Barrera alrededor de cóncavos/Corralito_04.jpg") }

            ]
        },
        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/08_Soporte para head de chancadora secundaria/1_800h.jpg"),
            name: 'Soporte para head de chancadora secundaria',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/08_Soporte para head de chancadora secundaria/1.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/08_Soporte para head de chancadora secundaria/2.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/08_Soporte para head de chancadora secundaria/3.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/08_Soporte para head de chancadora secundaria/4.jpg") }
            ]
        },
        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/09_Enfriador de inner bushing/INNER 02_800h.jpg"),
            name: 'Enfriador de inner bushing',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/09_Enfriador de inner bushing/INNER 02.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/09_Enfriador de inner bushing/INNER 03.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/09_Enfriador de inner bushing/INNER 04.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/09_Enfriador de inner bushing/INNER 05.jpg") }
            ]
        },
        {
            path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/10_Soporte_de_spider_chancadora_primaria/Spider _ 01_800h.jpg"),
            name: 'Soporte de spider chancadora primaria',
            variants: [
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/10_Soporte_de_spider_chancadora_primaria/Spider _ 01.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/10_Soporte_de_spider_chancadora_primaria/Spider _ 03.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/10_Soporte_de_spider_chancadora_primaria/Spider _ 04.jpg") },
                { path: require("../images/productos/2_Facilidades_para_cambio_de_concavos/10_Soporte_de_spider_chancadora_primaria/Spider_07.jpg") }
            ]
        },
    ],
    plataformas: [
        {
            path: require("../images/productos/3_Plataformas_de_acceso/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 06_800h.jpg"),
            name: 'Plataforma de acceso a mainshaft',
            variants: [
                { path: require("../images/productos/3_Plataformas_de_acceso/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 02.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 06.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/01_Plataforma de acceso a mainshaft/Plat Mainshaft _ 07.jpg") }
            ]
        },
        {
            path: require("../images/productos/3_Plataformas_de_acceso/03_Plataforma para remover pernos de spider/J-00_800h.jpg"),
            name: 'Plataforma para remover pernos de spider',
            variants: [
                { path: require("../images/productos/3_Plataformas_de_acceso/03_Plataforma para remover pernos de spider/J-00.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/03_Plataforma para remover pernos de spider/J-01.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/03_Plataforma para remover pernos de spider/J-04.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/03_Plataforma para remover pernos de spider/J-05.jpg") }
            ]
        },
        {
            path: require("../images/productos/3_Plataformas_de_acceso/04_Plataforma de acceso a JIB CRANE/2_800h.jpg"),
            name: 'Plataforma de acceso a JIB CRANE',
            variants: [
                { path: require("../images/productos/3_Plataformas_de_acceso/04_Plataforma de acceso a JIB CRANE/1.png") },
                { path: require("../images/productos/3_Plataformas_de_acceso/04_Plataforma de acceso a JIB CRANE/2.png") },
                { path: require("../images/productos/3_Plataformas_de_acceso/04_Plataforma de acceso a JIB CRANE/4.png") },
                { path: require("../images/productos/3_Plataformas_de_acceso/04_Plataforma de acceso a JIB CRANE/5.png") }
            ]
        },
        {
            path: require("../images/productos/3_Plataformas_de_acceso/05_Plataforma de acceso a molino de bolas/1_800h.jpg"),
            name: 'Plataforma de acceso a molino de bolas',
            variants: [
                { path: require("../images/productos/3_Plataformas_de_acceso/05_Plataforma de acceso a molino de bolas/1.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/05_Plataforma de acceso a molino de bolas/2.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/05_Plataforma de acceso a molino de bolas/3.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/05_Plataforma de acceso a molino de bolas/4.jpg") }
            ]
        },
        {
            path: require("../images/productos/3_Plataformas_de_acceso/06_Plataforma_de_acceso_a_chancadora_secundaria/Plataforma trompo_02_800h.jpg"),
            name: 'Plataforma de acceso a chancadora secundaria',
            variants: [
                { path: require("../images/productos/3_Plataformas_de_acceso/06_Plataforma_de_acceso_a_chancadora_secundaria/Plataforma trompo_02.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/06_Plataforma_de_acceso_a_chancadora_secundaria/Plataforma trompo_03.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/06_Plataforma_de_acceso_a_chancadora_secundaria/Plataforma trompo_05.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/06_Plataforma_de_acceso_a_chancadora_secundaria/Plataforma trompo_07.jpg") }
            ]
        },
        {
            path: require("../images/productos/3_Plataformas_de_acceso/07_Plataforma elevadora para acceder a pernos de molino de bolas/1_800h.jpg"),
            name: 'Plataforma elevadora para acceder a pernos de molino de bolas',
            variants: [
                { path: require("../images/productos/3_Plataformas_de_acceso/07_Plataforma elevadora para acceder a pernos de molino de bolas/1.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/07_Plataforma elevadora para acceder a pernos de molino de bolas/4.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/07_Plataforma elevadora para acceder a pernos de molino de bolas/5.jpg") },
                { path: require("../images/productos/3_Plataformas_de_acceso/07_Plataforma elevadora para acceder a pernos de molino de bolas/6.jpg") }
            ]
        },
    ],
    fajas: [
        {
            path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/1_Belt_winder/4_800h.jpg"),
            name: 'Belt_winder',
            variants: [
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/1_Belt_winder/2.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/1_Belt_winder/4.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/1_Belt_winder/7.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/1_Belt_winder/9.jpg") }
            ]
        },
        {
            path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/2_Mesa para soporte de belt Winder/2_800h.jpg"),
            name: 'Mesa para soporte de belt Winder',
            variants: [
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/2_Mesa para soporte de belt Winder/2.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/2_Mesa para soporte de belt Winder/4.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/2_Mesa para soporte de belt Winder/7.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/2_Mesa para soporte de belt Winder/9.jpg") }
            ]
        },
        {
            path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/3_Torcedor de faja transportadora/2_800h.jpg"),
            name: 'Torcedor de faja transportadora',
            variants: [
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/3_Torcedor de faja transportadora/1.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/3_Torcedor de faja transportadora/3.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/3_Torcedor de faja transportadora/5.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/3_Torcedor de faja transportadora/6.jpg") }
            ]
        },
        {
            path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/4_Torcedor doble para faja transportadora/1_800h.jpg"),
            name: 'Torcedor doble para faja transportadora',
            variants: [
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/4_Torcedor doble para faja transportadora/1.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/4_Torcedor doble para faja transportadora/2.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/4_Torcedor doble para faja transportadora/5.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/4_Torcedor doble para faja transportadora/6.jpg") }
            ]
        },
        {
            path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/5_Belti Winder compacto/1_800h.jpg"),
            name: 'Belti Winder compacto',
            variants: [
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/5_Belti Winder compacto/1.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/5_Belti Winder compacto/2.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/5_Belti Winder compacto/4.jpg") }
            ]
        },
        {
            path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/6_Atril para faja transportadora/1_800h.jpg"),
            name: 'Atril para faja transportadora',
            variants: [
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/6_Atril para faja transportadora/1.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/6_Atril para faja transportadora/2.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/6_Atril para faja transportadora/3.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/6_Atril para faja transportadora/4.jpg") }
            ]
        },
        {
            path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/7_Guiadores de polines/1_800h.jpg"),
            name: 'Guiadores de polines',
            variants: [
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/7_Guiadores de polines/1.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/7_Guiadores de polines/2.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/7_Guiadores de polines/3.jpg") },
                { path: require("../images/productos/4_Equipos_para_cambio_de_faja_transportadora/7_Guiadores de polines/4.jpg") }
            ]
        },
    ],
    grating: [
        {
            path: require("../images/productos/grating/1.jpg"),
            name: 'GRATING',
            variants: []
        },
        {
            path: require("../images/productos/grating/2.jpg"),
            name: 'GRATING',
            variants: []
        },
        {
            path: require("../images/productos/grating/3.jpg"),
            name: 'GRATING',
            variants: []
        },
        {
            path: require("../images/productos/grating/4.jpg"),
            name: 'GRATING',
            variants: []
        },
        {
            path: require("../images/productos/grating/6.jpg"),
            name: 'GRATING',
            variants: [
                { path: require("../images/productos/grating/5.jpg") },
                { path: require("../images/productos/grating/6.jpg") }

            ]
        },
    ]
}
